/**
 * Site reducer, wrapping core's.
 *
 * BL-0157 (TAIUIT scan 2026-09-29, "Error Page Disclosure"): core stores the
 * whole `@site` response in `state.site.data`, and Html.jsx serializes the
 * store into `window.__data` on every server-rendered page. That response
 * includes `plone.robots_txt` (~7.8 KB), so every page shipped the full
 * robots.txt body inline, which the scanner reads as disclosed internals.
 *
 * Nothing in redux reads that key. The only consumer in core or this addon is
 * `helpers/Robots/Robots.js`, which serves /robots.txt and fetches `@site`
 * itself with superagent rather than reading the store; `express/sitemapBrowse.js`
 * only mentions it in a comment. So it is dropped here, on the way in, and the
 * rest of the response is stored exactly as core stores it.
 *
 * store.js spreads `config.addonReducers` after core's reducers, so registering
 * this as `site` replaces core's slice -- the same mechanism
 * `querystringsearch` already uses (see index.ts).
 */
import { GET_SITE } from '@plone/volto/constants/ActionTypes';
import coreSite from '@plone/volto/reducers/site/site';

const OMITTED_KEYS = ['plone.robots_txt'];

const withoutOmittedKeys = (result) => {
  if (!result || typeof result !== 'object') return result;
  const data = { ...result };
  OMITTED_KEYS.forEach((key) => {
    delete data[key];
  });
  return data;
};

export default function site(state, action = {}) {
  const next = coreSite(state, action);
  if (action.type !== `${GET_SITE}_SUCCESS`) return next;
  return { ...next, data: withoutOmittedKeys(next.data) };
}
